import Service from '@/service/index.js';
import { getValueByType, getAfficheTextByType, isPurchaseTypeFlag, getUnitByGoodsType } from '@/utils/common.js';

export default {
  components: {
  },
  props: {
    projectInfo: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      purchaseProjectType: [],
      qualificationReview: [],
      purchaseType: [],
      purchaseStatus: [],
      projectCategoryList: [], // 项目分类
      purchaseGoodsType: [],
      citytitle: ''
    };
  },
  created () {
    const obj = {
      PURCHASE_PROJECT_TYPE: 'purchaseProjectType',
      QUALIFICATION_REVIEW: 'qualificationReview',
      PURCHASE_TYPE: 'purchaseType',
      PURCHASE_STATUS: 'purchaseStatus',
      PURCHASE_CATEGORY: 'projectCategoryList',
      PURCHASE_GOODS_TYPE: 'purchaseGoodsType'
    };
    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = res.data;
        }
      });
    });
  },
  computed: {
    getFontsOrigin () {
      let fundsText = '';
      if (this.projectInfo && this.projectInfo.fundsInfo && this.projectInfo.fundsInfo.length) {
        this.projectInfo.fundsInfo.forEach(fund => {
          if (fund.fundsSource !== '') {
            const fundsSource = fund.fundsSource && fund.fundsSource.toFixed(2);
            const fundsSourceProportion = fund.fundsSourceProportion && fund.fundsSourceProportion.toFixed(2);
            fundsText += fund.fundsSourceDesc + '：' + fundsSource + '元（' + fundsSourceProportion + '%）；';
          }
        });
      }
      return fundsText;
    },
    // 项目分类
    getProjectCategory () {
      let projectCategoryText = [];
      if (this.projectInfo && this.projectInfo.projectCategory) {
        this.projectInfo.projectCategory.map(item => {
          // 其他添加描述
          if (Number(item.projectCategory) === 11) {
            let otherText = item.projectCategoryValue + '：' + this.projectInfo.projectCategoryValue;
            projectCategoryText.push(otherText);
          } else {
            projectCategoryText.push(item.projectCategoryValue);
          }
        });
      }
      return projectCategoryText.join('、');
    }
  },
  methods: {
    getValueByType,
    getAfficheTextByType,
    isPurchaseTypeFlag,
    getUnitByGoodsType,
    formateAddress (address) {
      if (address) {
        return address.split(' ') && address.split(' ').length === 5 && address.split(' ').slice(2, 5) && address.split(' ').slice(2, 5).join('');
      }
    }
  }
};
